import React, { useState } from 'react';
import { Hash } from 'lucide-react';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton } from '../BulkFieldRow';

interface BulkItemNumberFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkItemNumberField({ onUpdate }: BulkItemNumberFieldProps) {
  const [itemNumber, setItemNumber] = useState('');
  const [itemNumber2, setItemNumber2] = useState('');
  const [itemNumberPrefix, setItemNumberPrefix] = useState(false);
  const [itemNumberSuffix, setItemNumberSuffix] = useState(false);
  const [itemNumberSerial, setItemNumberSerial] = useState(false);
  const [memoPrefix, setMemoPrefix] = useState(false);
  const [memoSuffix, setMemoSuffix] = useState(false);
  const [memoSerial, setMemoSerial] = useState(false);

  const handleApply = () => {
    const updates: BulkUpdates = {};

    if (itemNumber) updates.itemNumber = itemNumber;
    if (itemNumber2) updates.itemNumber2 = itemNumber2;
    if (itemNumberPrefix) updates.itemNumberPrefix = itemNumberPrefix;
    if (itemNumberSuffix) updates.itemNumberSuffix = itemNumberSuffix;
    if (itemNumberSerial) updates.itemNumberSerial = itemNumberSerial;
    if (memoPrefix) updates.memoPrefix = memoPrefix;
    if (memoSuffix) updates.memoSuffix = memoSuffix;
    if (memoSerial) updates.memoSerial = memoSerial;

    if (Object.keys(updates).length > 0) {
      onUpdate(updates);
      setItemNumber('');
      setItemNumber2('');
      setItemNumberPrefix(false);
      setItemNumberSuffix(false);
      setItemNumberSerial(false);
      setMemoPrefix(false);
      setMemoSuffix(false);
      setMemoSerial(false);
    }
  };

  const checkboxRow = (
    prefix: boolean,
    setPrefix: (v: boolean) => void,
    suffix: boolean,
    setSuffix: (v: boolean) => void,
    serial: boolean,
    setSerial: (v: boolean) => void
  ) => (
    <div className="flex flex-wrap gap-3 sm:gap-4">
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={prefix}
          onChange={(e) => {
            setPrefix(e.target.checked);
            if (e.target.checked) setSuffix(false);
          }}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <span className="ml-2 text-sm text-gray-600">文頭</span>
      </label>
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={suffix}
          onChange={(e) => {
            setSuffix(e.target.checked);
            if (e.target.checked) setPrefix(false);
          }}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <span className="ml-2 text-sm text-gray-600">文尾</span>
      </label>
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={serial}
          onChange={(e) => setSerial(e.target.checked)}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <span className="ml-2 text-sm text-gray-600">連番</span>
      </label>
    </div>
  );

  return (
    <div className="flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
      <div className="flex items-center gap-2 md:w-44 lg:w-52 md:shrink-0 md:pt-1">
        <Hash className="w-5 h-5 text-gray-500 shrink-0" />
        <span className="text-sm font-medium text-gray-900 md:text-gray-700">管理番号を変更</span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-3">
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3">
          <input
            type="text"
            value={itemNumber}
            onChange={(e) => setItemNumber(e.target.value)}
            placeholder="管理番号1"
            className="h-[30px] w-full sm:w-32 rounded-md border border-gray-300 bg-gray-50 px-3 text-sm"
          />
          {checkboxRow(
            itemNumberPrefix, setItemNumberPrefix,
            itemNumberSuffix, setItemNumberSuffix,
            itemNumberSerial, setItemNumberSerial
          )}
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3">
          <input
            type="text"
            value={itemNumber2}
            onChange={(e) => setItemNumber2(e.target.value)}
            placeholder="管理番号2"
            className="h-[30px] w-full sm:w-32 rounded-md border border-gray-300 bg-gray-50 px-3 text-sm"
          />
          {checkboxRow(
            memoPrefix, setMemoPrefix,
            memoSuffix, setMemoSuffix,
            memoSerial, setMemoSerial
          )}
          <BulkApplyButton
            disabled={!itemNumber && !itemNumber2}
            onClick={handleApply}
          />
        </div>
      </div>
    </div>
  );
}
